import React from 'react';
import { Box, Flex } from '@withjoy/joykit';

type PhoneFrameProps = Readonly<{
  maxHeight?: string;
  screenBackground?: string;
  children?: React.ReactNode;
}>;

const BEZEL_COLOR = '#2C2C2E';

export const PhoneFrame: React.FC<PhoneFrameProps> = ({ maxHeight, screenBackground = '#fff', children }) => {
  return (
    <Box
      maxHeight={maxHeight}
      overflow="hidden"
    >
      <Box
        backgroundColor={BEZEL_COLOR}
        borderRadius="55px 55px 0 0"
        padding="6px 6px 0 6px"
      >
        <Box
          backgroundColor={screenBackground}
          borderRadius="49px 49px 0 0"
          overflow="hidden"
        >
          <Flex
            justifyContent="center"
            paddingTop="10px"
            paddingBottom="8px"
          >
            <Box
              width="72px"
              height="20px"
              backgroundColor={BEZEL_COLOR}
              borderRadius="100px"
            />
          </Flex>
          {children}
        </Box>
      </Box>
    </Box>
  );
};
